// import React from "react";
// import PropTypes from "prop-types";
// import { TdGeneratorCondition } from "../../../Helper/TdGenerationCondition";

// const Tds = ({
//   eachTableData,
//   eachColoumnConfig,
//   onAudioHandler,
//   onPDFHandler,
//   onNotesHandler,
//   onSelectedRowHandler,
// }) => {
//   let value = eachColoumnConfig.dataColoumn;
//   let data = eachTableData[value];
//   let memberId = eachTableData.memberId;
//   let callId = eachTableData.callId;
//   let memberName = eachTableData.memberName;
//   const eachTd = TdGeneratorCondition(
//     eachColoumnConfig,
//     data,
//     eachTableData,
//     (audioUrl) => onAudioHandler(audioUrl, memberName, eachTableData.role, eachTableData.engagementDate),  // Pass memberName
//     onPDFHandler,
//     onNotesHandler,
//     onSelectedRowHandler,
//     memberId,
//     callId

//   );
//     console.log(eachTableData);
//   return (
//     <td
//       className={eachColoumnConfig.className}
//       data-heading={eachColoumnConfig.coloumnName}
//     >
//       {eachTd}
//     </td>
//   );
// };

// Tds.propTypes = {
//   eachTableData: PropTypes.object,
//   eachColoumnConfig: PropTypes.object,
//   id: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
//   onAudioHandler: PropTypes.func,
//   onPDFHandler: PropTypes.func,
//   onNotesHandler: PropTypes.func,
//   onSelectedRowHandler: PropTypes.func,
// };

// export default Tds;

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { TdGeneratorCondition } from "../../../Helper/TdGenerationCondition";

const Tds = ({
  eachTableData,
  eachColoumnConfig,
  onAudioHandler,
  onPDFHandler,
  onNotesHandler,
  onSelectedRowHandler,
}) => {
  // const [audioDuration, setAudioDuration] = useState(null);

  // useEffect(() => {
  //   console.log("audio without condition",eachColoumnConfig, eachTableData)
  //   if (
  //     eachColoumnConfig.coloumnType === "audio" &&
  //     eachTableData[eachColoumnConfig.dataColoumn]
  //   ) 
  //    console.log("audio inside condition",eachColoumnConfig, eachTableData)
  //   {
  //     const audio = new Audio(
  //       `${process.env.REACT_APP_GET_OPERATION_HOME_API}&secureId=${
  //         eachTableData[eachColoumnConfig.dataColoumn]
  //       }`
  //     );
  //     audio.addEventListener("loadedmetadata", () => {
  //       const totalSeconds = Math.floor(audio.duration);
  //       const minutes = Math.floor(totalSeconds / 60);
  //       const seconds = totalSeconds % 60;
  //       setAudioDuration(`${minutes}:${seconds < 10 ? "0" : ""}${seconds}`);
  //     });

  //     return () => {
  //       audio.removeEventListener("loadedmetadata", () => {});
  //     };
  //   }
  // }, [eachColoumnConfig, eachTableData]);

  const value = eachColoumnConfig.dataColoumn;
  const data = eachTableData[value];
  const memberId = eachTableData.memberId;
  const callId = eachTableData.callId;
  const memberName = eachTableData.memberName;

  const eachTd = TdGeneratorCondition(
    eachColoumnConfig,
    data,
    eachTableData,
    (audioUrl) =>
      onAudioHandler(
        audioUrl,
        memberName,
        eachTableData.role,
        eachTableData.engagementDate
      ),
    onPDFHandler,
    onNotesHandler,
    onSelectedRowHandler,
    memberId,
    callId,
    // audioDuration // ✅ pass duration
  );

  return (
    <td
      className={eachColoumnConfig.className}
      data-heading={eachColoumnConfig.coloumnName}
    >
      {eachTd}
    </td>
  );
};

Tds.propTypes = {
  eachTableData: PropTypes.object,
  eachColoumnConfig: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onAudioHandler: PropTypes.func,
  onPDFHandler: PropTypes.func,
  onNotesHandler: PropTypes.func,
  onSelectedRowHandler: PropTypes.func,
};

export default Tds;
